module.exports = __webpack_public_path__ + "static/media/logo.c5e43730.svg";